export default __webpack_public_path__ + "static/media/settingsWhite.00a4b0c0.svg";